exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-upload[data-v-1a0fc3bf]{border-top:0;box-shadow:none;-webkit-box-shadow:none}.fr-popup[data-v-1a0fc3bf]{position:relative;font-family:artifaktElementRegular;z-index:0!important;margin:0}.fr-popup .fr-layer[data-v-1a0fc3bf]{margin:0;margin-bottom:1em}.fr-popup .fr-file-upload-layer.drag-over[data-v-1a0fc3bf]{background:#ebebeb!important}.loading-overlay[data-v-1a0fc3bf]{opacity:.5;background-color:#f5f5f5;z-index:10}", ""]);

// exports
